import { useContext } from 'react';
import { __RouterContext } from 'react-router';

const Router = () => useContext(__RouterContext)
export default Router
